// Reporting-hierarchy level helpers (org_level is separate from auth role).
// Ladder: employee < manager < director < executive < ceo.

export const ORG_LEVELS = ['employee', 'manager', 'director', 'executive', 'ceo'] as const;
export type OrgLevel = (typeof ORG_LEVELS)[number];

export const ORG_LEVEL_LABELS: Record<string, string> = {
  employee: 'Employee',
  manager: 'Manager',
  director: 'Director',
  executive: 'Executive',
  ceo: 'CEO',
};

export const levelLabel = (lvl?: string): string =>
  (lvl && ORG_LEVEL_LABELS[lvl]) || 'Employee';

export const levelColor = (lvl?: string): string => {
  switch (lvl) {
    case 'ceo': return 'bg-purple-100 text-purple-800 border-purple-200';
    case 'executive': return 'bg-indigo-100 text-indigo-800 border-indigo-200';
    case 'director': return 'bg-blue-100 text-blue-800 border-blue-200';
    case 'manager': return 'bg-teal-100 text-teal-800 border-teal-200';
    default: return 'bg-slate-100 text-slate-700 border-slate-200';
  }
};

export const levelRank = (lvl?: string): number => {
  const i = ORG_LEVELS.indexOf((lvl || 'employee') as OrgLevel);
  return i < 0 ? 0 : i;
};
